import { render, staticRenderFns } from "./TemplateEmail.vue?vue&type=template&id=6c8e8538&scoped=true&"
import script from "./TemplateEmail.vue?vue&type=script&lang=js&"
export * from "./TemplateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e8538",
  null
  
)

export default component.exports